import { HeightMode } from '@wix/ambassador-app-service-webapp/types';
import { WidgetSize } from '../../../../types/unifiedComponents';
import { UnitSize } from '@wix/document-services-types';

export const chainPromisesAsync = <T>(
  array: T[],
  functionToApply: (item: T) => Promise<any>,
) =>
  array.reduce(
    (previousPromise, currentItem) =>
      previousPromise.then(() => functionToApply(currentItem)),
    Promise.resolve(),
  );

export const getSize = (size?: WidgetSize) => ({
  height:
    size?.height?.heightMode === HeightMode.FIXED && size?.height?.defaultHeight
      ? size?.height?.defaultHeight
      : 500,
  width: size?.width?.defaultWidth ?? 500,
  ...(size?.width?.stretchByDefault
    ? {
        docked: {
          left: { px: 0, vw: 0 },
          right: { px: 0, vw: 0 },
        },
      }
    : {}),
});

export const cleanPresetIdPrefix = (presetId: string) =>
  presetId.replace(/^#+/g, '');

export const getSizeValue = (unitSize: UnitSize | number): number =>
  typeof unitSize === 'number' ? unitSize : unitSize.value;

export const getUnitSize = (
  sizeValue: UnitSize | number,
): UnitSize & { type: 'px' } =>
  typeof sizeValue !== 'number'
    ? { ...sizeValue, type: 'px' }
    : { value: sizeValue, type: 'px' };
